export default "__VITE_ASSET__ChKYkJtg__"